import QtyCellValueText from './QtyCellValueText'
export default QtyCellValueText
